export const FETCH_DASHBOARD_DATA_SUCCESS = "FETCH_DASHBOARD_DATA_SUCCESS";
export const FETCH_DASHBOARD_DATA_FAILURE = "FETCH_DASHBOARD_DATA_FAILURE";
export const FETCH_BY_GUARD_SUCCESS = "FETCH_BY_GUARD_SUCCESS";
export const FETCH_BY_GUARD_FAILURE = "FETCH_BY_GUARD_FAILURE";
export const FETCH_BY_REGION_SUCCESS = "FETCH_BY_REGION_SUCCESS";
export const FETCH_BY_REGION_FAILURE = "FETCH_BY_REGION_FAILURE";
